import Vue from 'vue'

Vue.prototype.$peToEn = (amount) => {
  const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g]
  const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g]

  if (typeof amount === 'string') {
    for (let i = 0; i < 10; i++) {
      amount = amount.replace(persianNumbers[i], i).replace(arabicNumbers[i], i)
    }
  }

  return amount
}

Vue.prototype.$coinNumber = (amount) => {
  switch (true) {
    case (amount < 0.0001):
      return Number(Number(amount).toFixed(8))

    case (amount < 1):
      return Number(Number(amount).toFixed(6))

    case (amount <= 10):
      return Number(Number(amount).toFixed(2))

    case (amount > 10):
      return Number(Number(amount).toFixed(0))

    default :
      return Number(Number(amount).toFixed(2))
  }
}
